import { Typography, styled } from "@mui/material";

export const FullHeightContainer = styled("div")({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  border: "0 solid white", // Need this hack for CSS, hey ho
});

export const MainContainer = styled("div")({
  flexShrink: 0,
  flexGrow: 1,
  margin: 0,
});

export const PaddingContainer = styled("div")({
  margin: "1.55rem 1.55rem 7rem 1.55rem",
});

export const FooterContainer = styled("div")({
  flexShrink: 0,
});

export const TermsParagraph = styled("div")({
  margin: "0.2rem 0 1rem 0",

  "& ul": {
    padding: "0.5rem 2rem",
  },
});

export const TermsHead1 = styled(Typography)({
  fontWeight: 700,
  fontSize: "2.3rem",
  lineHeight: "2.3rem",
  margin: "3.5rem 0 2rem 0",
});

export const TermsHead2 = styled(Typography)({
  fontWeight: 100,
  margin: "2.2rem 0 1rem 0",
});
